import _defineProperty from "/opt/buildhome/repo/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/opt/buildhome/repo/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { isString, singleColorRegex, floatRegex } from '../utils.mjs';
var isColorString = function isColorString(type, testProp) {
  return function (v) {
    return Boolean(isString(v) && singleColorRegex.test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
  };
};
var splitColor = function splitColor(aName, bName, cName) {
  return function (v) {
    var _ref;
    if (!isString(v)) return v;
    var _v$match = v.match(floatRegex),
      _v$match2 = _slicedToArray(_v$match, 4),
      a = _v$match2[0],
      b = _v$match2[1],
      c = _v$match2[2],
      alpha = _v$match2[3];
    return _ref = {}, _defineProperty(_ref, aName, parseFloat(a)), _defineProperty(_ref, bName, parseFloat(b)), _defineProperty(_ref, cName, parseFloat(c)), _defineProperty(_ref, "alpha", alpha !== undefined ? parseFloat(alpha) : 1), _ref;
  };
};
export { isColorString, splitColor };